import styled, { css } from "styled-components";

export const ImageLoader = styled.div<{
  $isVisible: boolean;
}>`
  background-color: #dee0e3;
  height: 100%;
  left: -9999px;
  opacity: 0;
  position: absolute;
  top: 0;
  transition: opacity 0.2s ease-out;
  width: 100%;
  z-index: 0;

  ${({ $isVisible }) =>
    $isVisible &&
    css`
      left: 0;
      opacity: 1;
      z-index: 5;
    `}
`;
